export default "__VITE_ASSET__CaqcnR1___"